<template>

    <div class="popup" v-click-outside="hidePopup">
        <transition name="fade">
            <section class="popup__container" v-if="show">
                <slot></slot>
            </section>
        </transition>

        <a class="popup__link" href="#" @click.prevent="showPopup">{{popupTitle}}</a>
    </div>

</template>

<script>
export default {
    name: "popup",
    data(){
      return {
        show:false,
      };
    },
    props:['popupTitle'],
    methods:{
        showPopup(){
            this.show = true;
        },
        hidePopup(){
            this.show = false;
        }
    }
}
</script>

<style scoped>

</style>
